export const sitecoreDocumentationQuickAction = {
  type: 'ui',
  name: 'Sitecore Documentation',
  icon: {
    type: 'mdi',
    src: 'mdiBookOpenPageVariantOutline',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://doc.sitecore.com/?utm_source=cloud-portal&utm_medium=help-section',
  },
};
